import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { THUMB_PREVIEW_RATIO } from 'src/app/resources/common-id-config';
import { SUBJECT_NAMES } from 'src/app/resources/config';

export interface ProblemResultClickParams {
  problemId: string;
  isPremiumMemberOnly: boolean;
}

@Component({
  selector: 'app-common-id-problem-list-item',
  templateUrl: './problem-list-item.component.html',
  styleUrls: ['./problem-list-item.component.scss']
})
export class CommonIdProblemListItemComponent implements OnInit {
  @Input() problemId: string;
  @Input() isPremiumMemberOnly: boolean;
  @Input() subjectLabelStyleName: string;
  @Input() subjectName: string;
  @Input() level: number;
  @Input() levelName: string;
  @Input() universityName: string;
  @Input() year: string;
  @Input() daimonNumber: string;
  @Input() problemSummary: string;
  @Input() isAnswered: boolean;
  @Input() hasExternalData: boolean | undefined;

  @Output() resultClick = new EventEmitter<ProblemResultClickParams>();

  constructor() {}

  private LOG_SOURCE = this.constructor.name;
  subjectId: string;
  pcRatio: number;
  spRatio: number;

  ngOnInit() {
    this.subjectId = this.getSubjectIdByName(this.subjectName);
    this.setUpThumbPreviewRatio(this.subjectId);
  }

  private getSubjectIdByName(subjectName: string): string {
    return Object.entries(SUBJECT_NAMES).find(([_, v]) => v === subjectName)?.[0] ?? null;
  }

  private setUpThumbPreviewRatio(subjectId: string) {
    const ratio = THUMB_PREVIEW_RATIO.find(r => r.subjectId === subjectId);
    this.pcRatio = ratio?.pcRatio ?? 0.5;
    this.spRatio = ratio?.spRatio ?? 0.3;
  }
}
